var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDots = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.46341C11.3333 8.46341 12 9.14634 12 10C12 10.8537 11.3333 11.5366 10.5 11.5366C9.66667 11.5366 9 10.8537 9 10C9 9.14634 9.66667 8.46341 10.5 8.46341ZM9 4.53659C9 5.39024 9.66667 6.07317 10.5 6.07317C11.3333 6.07317 12 5.39024 12 4.53659C12 3.68293 11.3333 3 10.5 3C9.66667 3 9 3.68293 9 4.53659ZM9 15.4634C9 16.3171 9.66667 17 10.5 17C11.3333 17 12 16.3171 12 15.4634C12 14.6098 11.3333 13.9268 10.5 13.9268C9.66667 13.9268 9 14.6098 9 15.4634Z",
    fill: "#AABBC3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dots.3f3e2c41.svg";
export { ForwardRef as ReactComponent };